import { render, staticRenderFns } from "./NotAllowedView.vue?vue&type=template&id=2aef8f66&scoped=true"
import script from "./NotAllowedView.vue?vue&type=script&lang=js"
export * from "./NotAllowedView.vue?vue&type=script&lang=js"
import style0 from "./NotAllowedView.vue?vue&type=style&index=0&id=2aef8f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aef8f66",
  null
  
)

export default component.exports